module.exports = __webpack_public_path__ + "img/emoji_108.d42dc919.png";